module.exports = __webpack_public_path__ + "static/media/card-mobile-bg-standard.b04a57a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Plans/card-mobile-bg-standard.jpg
// module id = 332
// module chunks = 0